import axios from 'axios';
import config from '@/config';
import Auth from '@/utils/auth'
const auth = new Auth();
axios.defaults.baseURL = config.baseURL
axios.defaults.headers.post['Content-Type'] = 'application/json';

// const instance = axios.create({
//     baseURL: config.baseURL,
//     timeout: 1000,
//     headers: {
//         'Content-Type': 'application/json',
//     },
// });

class API {
    constructor() {
        // this.path = path
    }
    post(url, data) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'post',
                url: url,
                data,
                headers: {
                    token: auth.signParams(data)
                }
            }).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        });
    }
    get(url, params) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: url,
                params,
                headers: {
                    token: auth.signParams(params)
                }
            }).then(res => {
                console.log('get-data');
                console.log(res);
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default new API();